<div class="content">
  <a routerLink="/" aria-label="Home Page">
    <app-logo></app-logo>
    <app-site-name></app-site-name>
  </a>
  <nav>
    <ul>
      <li>
        <a routerLink="/account/profile" routerLinkActive="active">Account</a>
      </li>
      <li>
        <a routerLink="/account/orders" routerLinkActive="active">Orders</a>
      </li>
    </ul>
  </nav>
  <app-auth-button></app-auth-button>
</div>
